import $ from "jquery";
import Sortable from "sortablejs";
export class PlayerTiles {
    constructor(options = {}) {
        this._letters = [];
        this._element = $("#player-tiles").get(0);
        this._letterValues = options.letterValues || {};
        this._hasTouch = $("body").hasClass("has-touch");
        Sortable.create(this._element, {
            forceFallback: true,
            animation: 90,
            onEnd: e => {
                // the timeout is required, otherwise there is a
                // race condition when dropping tiles to the board
                // on whether this orr touchend will fire first, this
                // delay makes sure that touchend will
                if (this._hasTouch) {
                    setTimeout(() => this.unselect(), 60);
                }
            },
            onStart: e => {
                this.unselect();
                $(e.item).addClass("selected");
            },
        });
        this.render();
        this.$.mousedown(e => {
            if ($(e.target).hasClass("selected")) {
                this.unselect();
            }
            else {
                this.unselect();
                $(e.target).addClass("selected");
            }
        });
    }
    unselect() {
        this.$.find(".tile").removeClass("selected");
    }
    clear() {
        this._letters = [];
        this.onChange();
    }
    removeSelected() {
        const i = this._letters.indexOf(this.selectedLetter || "");
        this._letters.splice(i, 1);
        this.onChange();
    }
    append(letter) {
        if (letter === "") {
            return;
        }
        if (typeof letter == "string") {
            letter = letter.split("");
        }
        this._letters = this._letters.concat(letter);
        this._letters = this._letters.map(t => t.toUpperCase());
        this.onChange();
    }
    onChange() {
        this.render();
    }
    render() {
        this.$.html(this.html());
    }
    html() {
        return this._letters
            .map(t => t.toUpperCase())
            .map(t => `
				<span class='tile' data-letter='${t}'>
					${t}<span class='tile-value'>${this._letterValues[t.toLowerCase()] || 0}</span>
				</span>`.trim())
            .join("");
    }
    get $() {
        return $(this._element);
    }
    get selectedElement() {
        return this.$.find(".tile.selected");
    }
    get selectedLetter() {
        const el = this.selectedElement;
        return el ? el.attr("data-letter") : null;
    }
    get lettersNeededCount() {
        const lettersNeeded = 7;
        return lettersNeeded - this._letters.length;
    }
}
